import script from "./DataHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataHistory.vue?vue&type=script&setup=true&lang=ts"

import "./DataHistory.vue?vue&type=style&index=0&id=10758df1&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10758df1"]])

export default __exports__